import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Text } from 'foundations-components/components/Text';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { DefaultFieldKeys } from 'ExportDialog/Constants';
import { useEffect, useState } from 'react';
import { getEmailValidationState } from '../exportDialogUtilities';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function createValueExtractor(onChangeCallback) {
  return event => {
    onChangeCallback(event.target.value);
  };
}
const isSend = preference => {
  return preference === 'SEND';
};
const getNotificationText = (email, notification, value) => {
  if (email && notification) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "exportDialog.preference.exportToBothText",
      options: {
        value
      }
    });
  } else if (email) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "exportDialog.preference.exportToEmailText",
      options: {
        value
      }
    });
  } else {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "exportDialog.preference.exportToNotificationCenterText"
    });
  }
};
const EmailField = ({
  onChange,
  validationState,
  value,
  preferences
}) => {
  // is set to true if the email is invalid at the start of the component render
  //  should continue to be true even if the email is valid later on.
  const [showEmailInput] = useState(validationState === 'INVALID');
  const [isEmailValid, setIsEmailValid] = useState(validationState === 'VALID');
  const [emailString, setEmailString] = useState(value);
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsEmailValid(getEmailValidationState({
      [DefaultFieldKeys.EMAIL]: emailString
    }) === 'VALID');
  }, [emailString]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showEmailInput && /*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "exportDialog.fields.emailLabel"
      }),
      help: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "exportDialog.fields.emailDescription"
      }),
      error: !isEmailValid,
      validationMessage: !isEmailValid && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "exportDialog.emailErrors.invalidEmail"
      }),
      marginBlockEnd: "600",
      children: /*#__PURE__*/_jsx(TextInput, {
        defaultValue: value,
        onBlur: createValueExtractor(onChange),
        onChange: ({
          target: {
            value: newString
          }
        }) => setEmailString(newString)
      })
    }), validationState === 'VALID' && /*#__PURE__*/_jsx(Text, {
      typography: "body-200",
      marginBlockEnd: "600",
      children: getNotificationText(isSend(preferences.EMAIL), isSend(preferences.NOTIFICATION_SIDEBAR), value)
    })]
  });
};
export default EmailField;